export const validateRefregfSchema = json => {
    return true;
};
